import {default as momentApi} from 'moment/moment';
import {DateTime} from '../@types/DateTime';

export type MomentJs = momentApi.Moment;

export const serverDatePhpFormat = 'Y-m-d\\TH:i:sO';
export const serverDateMomentFormat = 'YYYY-MM-DD\\THH:mm:ssZZ';

export function moment(date?: number | string | Date | momentApi.Moment): MomentJs {
    if (date instanceof momentApi) {
        return momentApi(+date);
    } else if (typeof date === 'string') {
        return parseDate(date);
    }

    return momentApi(date);
}

export function now(): MomentJs {
    return moment();
}

export function parseDate(date: DateTime, defaultValue?: number | Date): MomentJs {
    const instance = momentApi(date, serverDateMomentFormat);

    return instance.isValid() ? instance : momentApi(defaultValue);
}

export function stringifyDate(date?: MomentJs | Date | number): DateTime {
    return moment(date).format(serverDateMomentFormat);
}

export function getDuration(date: number | string | Date | momentApi.Moment) {
    return momentApi.duration(
        moment(date).diff(moment())
    );
}
